import { render, staticRenderFns } from "./NextButton.vue?vue&type=template&id=8200d0b8&scoped=true"
import script from "./NextButton.vue?vue&type=script&lang=js"
export * from "./NextButton.vue?vue&type=script&lang=js"
import style0 from "./NextButton.vue?vue&type=style&index=0&id=8200d0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8200d0b8",
  null
  
)

export default component.exports